export default __webpack_public_path__ + "locales/lv/SingleSignOn.json?hash=75d5e12716fa18a0a8a76ce1ab72a563";